import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const ContactFormScreenOverlay = ({ isVisible=false, configuratorLink, onClose }) => {
    
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (document.head.querySelector('[data-contact-overlay-styles]')) return;

        const style = document.createElement('style');
        style.setAttribute('data-contact-overlay-styles', 'true');
        style.innerHTML = `
    .contact-form-fullscreen-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.6);
        z-index: 2147483647;
        display: flex;
        align-items: center;
        justify-content: center;            
        -webkit-backdrop-filter: blur(8px);
        backdrop-filter: blur(8px);
    }
    .contact-form-popup-content {
        background: black;        
        border-radius: 12px;
        width: 612px;
        min-height: 637px;        
        text-align: center;
        box-shadow: 0 10px 40px rgba(0,0,0,0.3);        
        display: flex;
        flex-direction: column;            
    }  
    .contact-form-inner {    
        position: relative;         
        align-items: start;
        justify-content: start;
        height: 100%;
        text-align: left;
        padding: calc(.25rem*12);
        font-family: "HagerScale Regular",Helvetica,system-ui,-apple-system,"Segoe UI",Roboto,Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji",sans-serif;
        gap: 0;
        flex-direction: column;
        display: flex;            
        color: white;
    }
    .contact-form-image img {
        max-width: 196px;
        height: auto;
        object-fit: contain;
    }   
    body .contact-form-fullscreen-overlay button.contact-form-button {        
        background-color: rgb(92, 194, 68);
        color: white;
        border: none;
        padding: 1rem;        
        cursor: pointer;       
        height: 60px;
        color: white;
        font-size: 1.125rem;
        font-weight: bold;
        line-height: calc(1.75/1.125);
        width: 100%;
        font-family: "HagerScale Regular",Helvetica,system-ui,-apple-system,"Segoe UI",Roboto,Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji",sans-serif;
        margin-bottom: calc(.25rem * 4);
        border-radius: calc(.625rem + 4px) !important;
    }
    body .contact-form-fullscreen-overlay button.contact-form-button:hover {        
        background-color: rgb(80, 170, 58);
    }   
    .contact-form-close {
        position: absolute;
        top: 16px;
        right: 16px;
        background: transparent;
        border: none;
        font-size: 24px;
        font-weight: bold;
        color: white;
        cursor: pointer;
        line-height: 1;
        width: 2rem;
        height: 2rem;
    }
    .contact-form-close:hover {
        color: #ccc;
    }   
    @media (max-width: 767px) {
        .contact-form-popup-content {
            width: 80%;
            height: auto;
            padding: 16px;            
            text-align: center;
        }               
    }
        `;
        document.head.appendChild(style);
        return () => style.remove();
    }, []);

    const onAbort = () => {
        if (onClose) {
            onClose();
        }
    }

    useEffect(() => {
        console.log({
            configuratorLink: configuratorLink
        });
    }, [configuratorLink]);

    if (!isVisible) return null;

    return createPortal(
        <div className="contact-form-fullscreen-overlay">
            <div className="contact-form-popup-content">                                
                <div className="contact-form-inner">
                    <div
                        className="contact-form-close"
                        onClick={onAbort}
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"></path></svg>
                    </div>                    
                    <div style={{marginBottom: "calc(.25rem * 8)", fontSize: "1.5rem", lineHeight: "calc(2/1.5)", display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem"}}>
                        <div style={{width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#5cc244", display: "flex", justifyContent: "center", alignItems: "center" }}><svg width={32} height={32} className="text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg></div>
                        <span>Fachpartner kontaktiert</span>
                    </div>
                    <div style={{ marginBottom: "calc(.25rem * 4)", fontSize: "1.875rem"}}>Jetzt System konfigurieren</div>
                    <div style={{ marginBottom: "calc(.25rem * 8)", fontSize: "1rem", lineHeight: "1.625rem", color: "oklch(70.7% .022 261.325)"}}>Konfigurieren Sie Ihr E3/DC System vorab - damit Ihr Fachpartner Ihr Angebot schneller und passgenauer vorbereiten kann.</div>
                    <div style={{ marginBottom: "calc(.25rem * 8)", borderRadius: "calc(.625rem + 4px)", backgroundColor: "color-mix(in oklab,oklch(27.4% .006 286.033)50%,transparent)", width: "100%" }}>
                        <div style={{padding: "calc(.25rem * 6)", display: "flex", flexDirection: "column", gap: "0.75rem"}}>
                            <div style={{display: "flex", flexDirection: "row",  gap: ".75rem", alignItems: "center"}}>
                                <div style={{width: 24, height: 24, borderRadius: "50%", backgroundColor: "#5cc24433", color: "#5cc244", display: "flex", justifyContent: "center", alignItems: "center"}}><svg width={"1rem"} height={"1rem"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg></div>
                                <div style={{color: "oklch(87.2% .01 258.338)"}}>Dauert ca. 2 Minuten</div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row",  gap: ".75rem", alignItems: "center"}}>
                                <div style={{width: 24, height: 24, borderRadius: "50%", backgroundColor: "#5cc24433", color: "#5cc244", display: "flex", justifyContent: "center", alignItems: "center"}}><svg width={"1rem"} height={"1rem"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg></div>
                                <div style={{color: "oklch(87.2% .01 258.338)"}}>Unverbindlich und kostenlos</div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row",  gap: ".75rem", alignItems: "center"}}>
                                <div style={{width: 24, height: 24, borderRadius: "50%", backgroundColor: "#5cc24433", color: "#5cc244", display: "flex", justifyContent: "center", alignItems: "center"}}><svg width={"1rem"} height={"1rem"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg></div>
                                <div style={{color: "oklch(87.2% .01 258.338)"}}>Ihre Angaben werden übernommen</div>
                            </div>
                        </div>
                    </div>                   
                    <button                    
                        onClick={() => {
                            setIsSubmitting(true);                            
                            window.location.href = configuratorLink                          
                            setTimeout(() => {                    
                                onAbort();
                                setIsSubmitting(false);
                            }, 500);  
                        }}
                        className='contact-form-button'                        
                        >                            
                        {isSubmitting ? (
                        // Show loading spinner while submitting
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Lädt...</span>
                        </div>
                        ) : 'Konfigurator starten'}
                    </button>                        
                    <div style={{width: "100%", textAlign: "center", fontSize: "0.875rem", lineHeight: "1.625rem", color: "oklch(55.1% .027 264.364)"}}>Sie können jederzeit speichern oder später fortsetzen</div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ContactFormScreenOverlay;
